import PropTypes from 'prop-types';
import { memo } from 'react';
import Stack from '@mui/material/Stack';
//
import List from '@mui/material/List';
import { navMiniConfig } from '../config';
import NavList from './nav-list';
import { StyledSubheader } from '../vertical/styles';

// ----------------------------------------------------------------------

function NavSectionMini({ data, config, sx, ...other }) {
  return (
    <Stack sx={sx} {...other}>
      {data.map((group, index) => (
        <Group
          key={group.subheader || index}
          subheader={group.miniSubheader || group.subheader}
          items={group.items}
          config={navMiniConfig(config)}
        />
      ))}
    </Stack>
  );
}

NavSectionMini.propTypes = {
  config: PropTypes.object,
  data: PropTypes.array,
  sx: PropTypes.object,
};

export default memo(NavSectionMini);

// ----------------------------------------------------------------------

function Group({ subheader, items, config }) {
  const renderContent = items.map((list) => (
    <NavList
      key={list.title + list.path}
      data={list}
      depth={1}
      hasChild={!!list.children}
      config={config}
    />
  ));

  return (
    <List disablePadding sx={{ px: 2 }}>
      {subheader ? (
        <>
          <StyledSubheader disableGutters disableSticky config={config}>
            {subheader}
          </StyledSubheader>

          {renderContent}
        </>
      ) : (
        renderContent
      )}
    </List>
  );
}

Group.propTypes = {
  subheader: PropTypes.string,
  config: PropTypes.object,
  items: PropTypes.array,
};
